/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Spec_PlatformsInputs */

const en_fc_home_spec_platforms = /** @type {(inputs: Fc_Home_Spec_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Fc_Home_Spec_PlatformsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_spec_platforms = /** @type {((inputs?: Fc_Home_Spec_PlatformsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Spec_PlatformsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_spec_platforms(inputs)
});
export { fc_home_spec_platforms as "fc.home.spec.platforms" }